import axios from 'axios';
import { handleAdminDashboardHttp401 } from '../lib/adminSession';
import { getAdminConsoleToken } from '../lib/adminConsoleToken';
import { isOidcAdminAuth } from '../lib/oidc/oidcConfig';
import { attachOidcBearer, handleOidcAxiosError } from '../lib/oidc/oidcAxios';

/**
 * Base URL for employer-verification ops routes.
 * - Empty: browser uses same-origin path `/api/employer-verification/...` (Vite proxies to EMS service).
 * - Absolute: direct host call, e.g. `http://ev-host:5000`.
 */
export function employerVerificationDashboardBaseUrl(): string {
  const raw = import.meta.env.VITE_EMPLOYER_VERIFICATION_API_BASE as
    | string
    | undefined;
  const base = typeof raw === 'string' ? raw.trim().replace(/\/$/, '') : '';
  return base;
}

export const employerVerificationDashboardHttp = axios.create({
  baseURL: employerVerificationDashboardBaseUrl(),
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

employerVerificationDashboardHttp.interceptors.request.use((config) => {
  if (isOidcAdminAuth()) return attachOidcBearer(config);
  const t = getAdminConsoleToken();
  if (t) (config.headers as Record<string, string>).Authorization = `Bearer ${t}`;
  return config;
});

employerVerificationDashboardHttp.interceptors.response.use(
  (r) => r,
  (err: unknown) =>
    isOidcAdminAuth()
      ? handleOidcAxiosError(employerVerificationDashboardHttp, err)
      : handleAdminDashboardHttp401(err),
);
